import React, { useEffect, useState } from "react";
import firstimg from "../../../img/step8.png";
import BackImg from "../../../img/back.svg";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { PiHeadphonesLight } from "react-icons/pi";
import NavHear from "./NavHear";
import Footer from "./TestFooter/Footer";
import { Link, useNavigate } from "react-router-dom";
import "./heartest.css";
import { useDispatch } from "react-redux";
import { testQuestion } from "../../../Helper/Redux/API";

function Step8() {
  const history = useNavigate();
  const [selectedOption, setSelectedOption] = useState(
    JSON.parse(localStorage.getItem("step8"))?.answer_id
  ); // state to track selected option
  const [questionId, setQuestionId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const handleRadioChange = (e) => {
    setSelectedOption(e);

    let step8Data = {
      question_id: questionId,
      answer_id: e,
    };
    localStorage.setItem("step8", JSON.stringify(step8Data));
    setTimeout(() => {
      history("/hearingtest/setup-instructions");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 1000);
  };
  const [question, setQuestion] = useState("");
  const [answerOption, serAnswerOption] = useState([]);

  const dispatch = useDispatch();

  const getQuestion = () => {
    const data = {
      page_number: 7,
    };
    try {
      dispatch(testQuestion(data)).then((res) => {
        if (res?.payload?.status === true) {
          setQuestion(res?.payload?.data[0]?.title);
          setQuestionId(res?.payload?.data[0]?.id);
          serAnswerOption(res?.payload?.data[0]?.options);
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getQuestion();
  }, []);

  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    // Check if there's a value in localStorage
    const localStorageValue = JSON.parse(localStorage.getItem("step8"));
    if (localStorageValue && localStorageValue.answer_id) {
      // Set showButton to true if there's a value
      setShowButton(true);
    } else {
      // Set showButton to false if there's no value
      setShowButton(false);
    }
  }, []);
  return (
    <>
      <div className="test-from">
        <NavHear />{" "}
        <section className="step_form">
          <div className="container">
            {/* container start */}
            <section className="step_1 step2 step7  wow  fadeInUp animated">
              <div className="Back_div">
                <Link to="/hearingtest/listening-situations/4">
                  <img src={BackImg} alt="back" className="img-fluid" />
                </Link>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="step1_img">
                    <img src={firstimg} className="img-fluid" alt="first-img" />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="step1_text">
                    <h1>Select your headphones</h1>
                    <p className="new_space">
                      {/* Select your headphone or earphone style and put them on. */}
                      {question}
                    </p>
                    <div className="step2_seletct step4_seletct">
                      <h5> Select your option</h5>

                      <ul className="list_item hearselect">
                        {answerOption?.map((option, i) => (
                          <li key={i}>
                            <div
                              className={`form-check form-check-inline ${
                                selectedOption == option?.id ? "checked" : ""
                              }`}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name="inlineRadioOptions"
                                id="inlineRadio2"
                                value={option?.id}
                                checked={selectedOption == option?.id}
                                onChange={(e) =>
                                  handleRadioChange(e.target.value)
                                }
                              />
                              <span className="raound_text"></span>
                              <label
                                className="form-check-label"
                                for="inlineRadio2"
                              >
                                <span> {option?.title} </span>
                                {i == "0" ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="22"
                                    viewBox="0 0 20 22"
                                    fill="none"
                                  >
                                    <path
                                      d="M16.9815 8.43527V7.28295C16.9815 5.35139 16.2141 3.49894 14.8483 2.13313C13.4825 0.767308 11.6301 0 9.69851 0C7.76695 0 5.9145 0.767308 4.54868 2.13313C3.18287 3.49894 2.41556 5.35139 2.41556 7.28295V8.43527C1.56682 8.80899 0.872221 9.46294 0.448047 10.2876C0.0238724 11.1123 -0.104131 12.0577 0.0854659 12.9655C0.275063 13.8733 0.770751 14.6884 1.48955 15.2743C2.20834 15.8603 3.10662 16.1816 4.03399 16.1843H5.65242V8.09216H4.03399V7.28295C4.03399 5.78062 4.63079 4.33983 5.69309 3.27753C6.75539 2.21523 8.19618 1.61843 9.69851 1.61843C11.2008 1.61843 12.6416 2.21523 13.7039 3.27753C14.7662 4.33983 15.363 5.78062 15.363 7.28295V8.09216H13.7446V16.1843H15.363C16.2904 16.1816 17.1887 15.8603 17.9075 15.2743C18.6263 14.6884 19.1219 13.8733 19.3115 12.9655C19.5011 12.0577 19.3731 11.1123 18.949 10.2876C18.5248 9.46294 17.8302 8.80899 16.9815 8.43527ZM4.03399 14.5659C3.39014 14.5659 2.77266 14.3101 2.31738 13.8549C1.86211 13.3996 1.60634 12.7821 1.60634 12.1382C1.60634 11.4944 1.86211 10.8769 2.31738 10.4216C2.77266 9.96637 3.39014 9.7106 4.03399 9.7106V14.5659ZM15.363 14.5659V9.7106C16.0069 9.7106 16.6244 9.96637 17.0796 10.4216C17.5349 10.8769 17.7907 11.4944 17.7907 12.1382C17.7907 12.7821 17.5349 13.3996 17.0796 13.8549C16.6244 14.3101 16.0069 14.5659 15.363 14.5659Z"
                                      fill="#737373"
                                    />
                                    <path
                                      d="M16 16C16.1667 17.1667 15.8 19.5 13 19.5C10.2 19.5 8.5 19.5 8 19.5C7.33333 19.5 6 19.9 6 21.5"
                                      stroke="#737373"
                                      stroke-width="1.5"
                                    />
                                  </svg>
                                ) : i == "1" ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="21"
                                    viewBox="0 0 18 21"
                                    fill="none"
                                  >
                                    <path
                                      d="M2 3.5C2 2.94772 1.55228 2.5 1 2.5C0.447715 2.5 0 2.94772 0 3.5H2ZM8 9V16H10V9H8ZM2 16V3.5H0V16H2ZM5 19C3.34315 19 2 17.6569 2 16H0C0 18.7614 2.23858 21 5 21V19ZM8 16C8 17.6569 6.65685 19 5 19V21C7.76142 21 10 18.7614 10 16H8Z"
                                      fill="#737373"
                                    />
                                    <path
                                      d="M17 17V5C17 2.79086 15.2091 1 13 1V1C10.7909 1 9 2.79086 9 5V14"
                                      stroke="#737373"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                    />
                                    <circle
                                      cx="3"
                                      cy="4"
                                      r="3"
                                      fill="#737373"
                                    />
                                    <circle
                                      cx="15"
                                      cy="17"
                                      r="3"
                                      fill="#737373"
                                    />
                                  </svg>
                                ) : i == "2" ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="17"
                                    viewBox="0 0 20 17"
                                    fill="none"
                                  >
                                    <path
                                      d="M16.9815 8.43527V7.28295C16.9815 5.35139 16.2141 3.49894 14.8483 2.13313C13.4825 0.767308 11.6301 0 9.69851 0C7.76695 0 5.9145 0.767308 4.54868 2.13313C3.18287 3.49894 2.41556 5.35139 2.41556 7.28295V8.43527C1.56682 8.80899 0.872221 9.46294 0.448047 10.2876C0.0238724 11.1123 -0.104131 12.0577 0.0854659 12.9655C0.275063 13.8733 0.770751 14.6884 1.48955 15.2743C2.20834 15.8603 3.10662 16.1816 4.03399 16.1843H5.65242V8.09216H4.03399V7.28295C4.03399 5.78062 4.63079 4.33983 5.69309 3.27753C6.75539 2.21523 8.19618 1.61843 9.69851 1.61843C11.2008 1.61843 12.6416 2.21523 13.7039 3.27753C14.7662 4.33983 15.363 5.78062 15.363 7.28295V8.09216H13.7446V16.1843H15.363C16.2904 16.1816 17.1887 15.8603 17.9075 15.2743C18.6263 14.6884 19.1219 13.8733 19.3115 12.9655C19.5011 12.0577 19.3731 11.1123 18.949 10.2876C18.5248 9.46294 17.8302 8.80899 16.9815 8.43527ZM4.03399 14.5659C3.39014 14.5659 2.77266 14.3101 2.31738 13.8549C1.86211 13.3996 1.60634 12.7821 1.60634 12.1382C1.60634 11.4944 1.86211 10.8769 2.31738 10.4216C2.77266 9.96637 3.39014 9.7106 4.03399 9.7106V14.5659ZM15.363 14.5659V9.7106C16.0069 9.7106 16.6244 9.96637 17.0796 10.4216C17.5349 10.8769 17.7907 11.4944 17.7907 12.1382C17.7907 12.7821 17.5349 13.3996 17.0796 13.8549C16.6244 14.3101 16.0069 14.5659 15.363 14.5659Z"
                                      fill="#737373"
                                    />
                                  </svg>
                                ) : i == "3" ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="23"
                                    height="19"
                                    viewBox="0 0 23 19"
                                    fill="none"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M9.03007 11.015L11.0101 15.4562C11.1751 15.8263 11.0788 16.2149 11.0101 16.3629C9.66293 19.146 6.71082 19.1879 5.40316 18.861C2.70888 18.4465 1.57887 15.5302 1.35064 14.1238C0.74369 11.4888 0.678307 5.26627 0.721484 2.4844H3.64522V11.8663C3.60081 12.1919 3.6884 12.3227 3.73774 12.3474C3.93019 12.5102 4.17568 12.2425 4.27438 12.0883C5.29583 11.0224 6.66148 10.682 7.21662 10.645C7.35848 10.6388 7.76435 10.6264 8.25288 10.6264C8.7414 10.6264 8.97456 10.8855 9.03007 11.015ZM11.7867 15.1971C12.0236 15.7152 12.3666 15.5364 12.5084 15.3821C13.6335 14.8048 13.6557 13.6489 13.5262 13.1431L12.6935 11.2556C11.9385 9.70122 10.5038 9.73206 9.88076 9.94178C9.54028 10.0602 9.55385 10.2872 9.60319 10.3859L11.7867 15.1971ZM3.68177 1.78121V1.28159C3.6756 0.954674 3.48562 0.278637 2.77504 0.189814H1.51673C1.25766 0.226824 0.739532 0.485889 0.739532 1.22607V1.78121H3.68177Z"
                                      fill="#737373"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M14.1281 7.98489L12.1481 3.54378C11.9831 3.17369 12.0794 2.78509 12.1481 2.63705C13.4953 -0.146048 16.4474 -0.187992 17.755 0.138923C20.4493 0.553427 21.5793 3.46976 21.8076 4.87611C22.4145 7.51117 22.4799 13.7337 22.4367 16.5155H19.513V7.13368C19.5574 6.808 19.4698 6.67723 19.4205 6.65256C19.228 6.48972 18.9825 6.75742 18.8838 6.91162C17.8624 7.97749 16.4967 8.31798 15.9416 8.35499C15.7997 8.36115 15.3938 8.37349 14.9053 8.37349C14.4168 8.37349 14.1836 8.11443 14.1281 7.98489ZM11.3715 3.80284C11.1346 3.28471 10.7917 3.46359 10.6498 3.61779C9.5247 4.19514 9.50249 5.35106 9.63203 5.85685L10.4647 7.74433C11.2197 9.29872 12.6545 9.26788 13.2774 9.05816C13.6179 8.93973 13.6044 8.71274 13.555 8.61405L11.3715 3.80284ZM19.4764 17.2187V17.7184C19.4826 18.0453 19.6726 18.7213 20.3832 18.8101H21.6415C21.9005 18.7731 22.4187 18.514 22.4187 17.7739V17.2187H19.4764Z"
                                      fill="#737373"
                                    />
                                  </svg>
                                ) : (
                                  ""
                                )}
                              </label>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {showButton && (
                <Link to="/hearingtest/setup-instructions">
                  <button className="next_btn">Next</button>
                </Link>
              )}
            </section>
            {/* container end */}
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
}

export default Step8;
